import { getUser, GQLGetUser } from 'graphql/users/queries';
import { UseQueryOptions, useQuery } from 'react-query';

type Params = {
  config?: UseQueryOptions<GQLGetUser, unknown, GQLGetUser, any>;
};

export const useGetUser = ({ config }: Params) =>
  useQuery('getCurrentUser', getUser, {
    ...config,
    refetchOnWindowFocus: false,
  });
